import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "notification-panel__content" }
const _hoisted_4 = { class: "form estate-setup-form" }
const _hoisted_5 = { class: "form-inline-group fg1" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = { class: "form-field multiple-inputs no-wrap checkboxes" }
const _hoisted_9 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_12 = { class: "check-label" }
const _hoisted_13 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_16 = { class: "checkbox" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_19 = { class: "checkbox-switch" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_22 = { class: "check-label" }
const _hoisted_23 = { class: "page-header" }
const _hoisted_24 = { class: "width-wrap" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_28 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_29 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_30 = { class: "estate-add" }
const _hoisted_31 = { class: "width-wrap" }
const _hoisted_32 = { class: "form-heading" }
const _hoisted_33 = { class: "form-section has-aside" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { for: "frm-estateAddForm_title" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "help" }
const _hoisted_38 = {
  key: 0,
  class: "form-error"
}
const _hoisted_39 = {
  key: 1,
  class: "form-error"
}
const _hoisted_40 = { for: "frm-estateAddForm_maxFloor" }
const _hoisted_41 = { class: "input-group" }
const _hoisted_42 = { class: "input-group-prepend" }
const _hoisted_43 = { class: "input-group-append" }
const _hoisted_44 = {
  key: 0,
  class: "form-error"
}
const _hoisted_45 = {
  key: 1,
  class: "form-error"
}
const _hoisted_46 = { class: "form-field" }
const _hoisted_47 = { for: "frm-estateAddForm_engineeringNetwork" }
const _hoisted_48 = { class: "checkboxlist grid-4" }
const _hoisted_49 = { class: "checkbox" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_51 = { class: "checkbox" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_53 = { class: "checkbox" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_55 = { class: "checkbox" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_57 = { for: "frm-estateAddForm_virtualTourLink" }
const _hoisted_58 = { for: "frm-estateAddForm_videoLink" }
const _hoisted_59 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_60 = { class: "form-upload-photo aspect-ratio aspect-ratio-16-9" }
const _hoisted_61 = { class: "aspect-ratio-body" }
const _hoisted_62 = {
  key: 0,
  class: "photo bordered is-uploaded"
}
const _hoisted_63 = {
  key: 1,
  class: "upload-placeholder placeholder-empty"
}
const _hoisted_64 = { class: "upload-placeholder-title" }
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = {
  key: 0,
  class: "form-error"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "section section--gray estate-add__gallery" }
const _hoisted_69 = { class: "width-wrap" }
const _hoisted_70 = { class: "form-heading" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_72 = {
  class: "upload-placeholder",
  ref: "fileuploader"
}
const _hoisted_73 = { class: "thumb-image" }
const _hoisted_74 = ["src"]
const _hoisted_75 = {
  key: 2,
  class: "image-label"
}
const _hoisted_76 = {
  key: 3,
  class: "thumb-text"
}
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "section estate-add__info" }
const _hoisted_79 = { class: "width-wrap" }
const _hoisted_80 = { for: "frm-estateAddForm_description" }
const _hoisted_81 = ["placeholder"]
const _hoisted_82 = {
  key: 0,
  class: "form-error"
}
const _hoisted_83 = { class: "width-wrap" }
const _hoisted_84 = { for: "frm-estateAddForm_country" }
const _hoisted_85 = { class: "width-wrap" }
const _hoisted_86 = {
  key: 0,
  class: "form-error"
}
const _hoisted_87 = {
  key: 0,
  class: "section estate-add__footer"
}
const _hoisted_88 = { class: "width-wrap" }
const _hoisted_89 = { class: "button button--primary is-size-medium" }
const _hoisted_90 = { class: "notification-panel__content" }
const _hoisted_91 = { class: "form estate-setup-form" }
const _hoisted_92 = { class: "form-inline-group fg1" }
const _hoisted_93 = { class: "form-field" }
const _hoisted_94 = { class: "form-field" }
const _hoisted_95 = { class: "form-field multiple-inputs no-wrap checkboxes" }
const _hoisted_96 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_97 = ["disabled"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_99 = { class: "check-label" }
const _hoisted_100 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_101 = ["checked"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_103 = { class: "checkbox" }
const _hoisted_104 = ["checked"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_106 = { class: "checkbox-switch" }
const _hoisted_107 = ["disabled"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_109 = { class: "check-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_FlashMessage = _resolveComponent("FlashMessage")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_SortableItem = _resolveComponent("SortableItem")!
  const _component_SortableList = _resolveComponent("SortableList")!
  const _component_MapPosition = _resolveComponent("MapPosition")!
  const _component_FixedElement = _resolveComponent("FixedElement")!
  const _component_AdPreview = _resolveComponent("AdPreview")!
  const _component_Cropper = _resolveComponent("Cropper")!
  const _directive_handle = _resolveDirective("handle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, "\r\n      " + _toDisplayString(_ctx.isInsert ? _ctx.$t('AdDeveloperProjectForm.title-insert') : _ctx.$t('AdDeveloperProjectForm.title-edit')) + "\r\n    ", 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isEdit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["notification-panel", _ctx.notificationClass]),
            ref: "topNotificationPanel"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["width-wrap", { 'disabled-all': _ctx.isLoading }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
                return (_openBlock(), _createBlock(_component_FlashMessage, {
                  key: index,
                  message: message
                }, {
                  default: _withCtx(() => [
                    (message.code == 'confirmemail')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!_ctx.isConfirmEmailSent)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "button button--warning reversed",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendConfirmEmail && _ctx.sendConfirmEmail(...args)))
                              }, _toDisplayString(_ctx.$t('AdForm.button-send-confirm-email')), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('AdForm.confirm-email-success', { email: _ctx.user.email })), 1))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["message"]))
              }), 128)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("form", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "button button--primary",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save(true)))
                      }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-save-short' : 'AdDeveloperProjectForm.button-save')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "button button--primary reversed",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onShowPreview && _ctx.onShowPreview(...args)))
                      }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-preview-short' : 'AdForm.button-preview')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_multiselect, {
                            key: 0,
                            class: "multiselect-statuses w200",
                            modelValue: _ctx.publishStatus,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.publishStatus) = $event)),
                            options: _ctx.publishStatuses,
                            "show-labels": false,
                            searchable: false,
                            "allow-empty": false
                          }, {
                            singleLabel: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.status-change')), 1)
                            ]),
                            option: _withCtx(({ option }) => [
                              (option === 'publish')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isPublished) = $event)),
                                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                      disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                    }, null, 40, _hoisted_10), [
                                      [_vModelCheckbox, _ctx.isPublished]
                                    ]),
                                    _hoisted_11,
                                    _createElementVNode("span", _hoisted_12, [
                                      (_ctx.form.isPublished)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                          ], 64))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (option === 'archive')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.form.isArchived,
                                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                    }, null, 40, _hoisted_14),
                                    _hoisted_15
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("label", _hoisted_16, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.form.isArchived,
                                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                              }, null, 40, _hoisted_17),
                              _hoisted_18
                            ]),
                            _createElementVNode("label", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isPublished) = $event)),
                                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                              }, null, 40, _hoisted_20), [
                                [_vModelCheckbox, _ctx.isPublished]
                              ]),
                              _hoisted_21,
                              _createElementVNode("span", _hoisted_22, [
                                (_ctx.form.isPublished)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                    ], 64))
                              ])
                            ])
                          ], 64))
                    ])
                  ])
                ])
              ])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          (_ctx.isInsert)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.title-insert')), 1),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdForm.logged-in-as')) + " ", 1),
                      _createVNode(_component_router_link, { to: { name: 'UserProfile' } }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.user.userName), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.isEdit)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_26, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.title-edit')), 1))
              : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["page-content", { 'pb-0': _ctx.isEdit, 'pt-0': !_ctx.isEdit }])
      }, [
        (_ctx.showFormMessages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_ctx.isSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('AdForm.success-message')), 1))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flashmessage flash-danger"
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("form", {
            class: _normalizeClass(["form", { 'disabled-all': _ctx.isLoading }]),
            onSubmit: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.save(true)), ["prevent"])),
            autocomplete: "off"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["section estate-add__parameters", { 'pt-0': _ctx.isEdit }])
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.form-header')), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field width-75", { 'is-danger': _ctx.v$.form.title.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.title')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.form.title.$model) = $event)),
                        type: "text",
                        id: "frm-estateAddForm_title",
                        placeholder: _ctx.$t('AdDeveloperProjectForm.title-placeholder'),
                        name: "title",
                        class: "form-control is-required"
                      }, null, 8, _hoisted_36), [
                        [
                          _vModelText,
                          _ctx.v$.form.title.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.title-help', {
                        currentCount: _ctx.form.title ? _ctx.form.title.length : 0,
                        maxCount: _ctx.v$.form.title.maxLength.$params.max,
                      })), 1),
                      (_ctx.v$.form.title.$dirty && _ctx.v$.form.title.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.title.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.title.maxLength.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.title.maxLength.$params.max })), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field width-25", { 'is-danger': _ctx.v$.form.maxFloor.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.maxFloor')) + ":", 1),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "button",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.subtractMaxFloor && _ctx.subtractMaxFloor(...args)))
                          }, "-")
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "frm-estateAddForm_maxFloor",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.form.maxFloor.$model) = $event)),
                          name: "maxFloor",
                          class: "form-control is-required"
                        }, null, 512), [
                          [_vModelText, _ctx.v$.form.maxFloor.$model]
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "button",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addMaxFloor && _ctx.addMaxFloor(...args)))
                          }, "+")
                        ])
                      ]),
                      (_ctx.v$.form.maxFloor.$dirty && _ctx.v$.form.maxFloor.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.maxFloor.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.maxFloor.decimal.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('AdForm.networks')) + ":", 1),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("label", _hoisted_49, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasWaterNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_water",
                            name: "water",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.form.hasWaterNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasWaterNetwork.$model]
                          ]),
                          _hoisted_50
                        ]),
                        _createElementVNode("label", _hoisted_51, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasGasNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_gas",
                            name: "gas",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.form.hasGasNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasGasNetwork.$model]
                          ]),
                          _hoisted_52
                        ]),
                        _createElementVNode("label", _hoisted_53, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasElectricityNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_electricity",
                            name: "electricity",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.form.hasElectricityNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasElectricityNetwork.$model]
                          ]),
                          _hoisted_54
                        ]),
                        _createElementVNode("label", _hoisted_55, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasCanalizationNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_canalization",
                            name: "canalization",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.form.hasCanalizationNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasCanalizationNetwork.$model]
                          ]),
                          _hoisted_56
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.virtualTourLink.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('AdForm.virtualTourLink')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.v$.form.virtualTourLink.$model) = $event)),
                        type: "text",
                        id: "frm-estateAddForm_virtualTourLink",
                        name: "virtualTourLink",
                        class: "form-control"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.virtualTourLink.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.videoLink.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('AdForm.videoLink')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.v$.form.videoLink.$model) = $event)),
                        type: "text",
                        id: "frm-estateAddForm_videoLink",
                        name: "videoLink",
                        class: "form-control"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.videoLink.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ], 2)
                  ]),
                  (_ctx.logoImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.logoImage.isError }])
                        }, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              (_ctx.logoImage.isSuccess)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    (_ctx.logoImage.isSuccess)
                                      ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                          key: 0,
                                          url: _ctx.logoImage.url,
                                          width: 320,
                                          height: 180,
                                          hrmode: "max",
                                          alt: _ctx.logoImage.file,
                                          draggable: false
                                        }, null, 8, ["url", "alt"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", {
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.deleteLogoFile())),
                                      class: "delete-photo"
                                    }),
                                    _createElementVNode("span", {
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.editLogoFile())),
                                      class: "edit-photo"
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("label", _hoisted_63, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/png, image/jpeg",
                                      ref: "logoImage",
                                      onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleLogoImageUpload()))
                                    }, null, 544),
                                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.logo-button')), 1),
                                    _createElementVNode("i", {
                                      innerHTML: _ctx.$t('AdDeveloperProjectForm.logo-button-info')
                                    }, null, 8, _hoisted_65)
                                  ])),
                              (_ctx.logoImage.isUploading)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "progress-bar",
                                    style: _normalizeStyle({ width: _ctx.logoImage.uploadPercentage + '%' })
                                  }, null, 4))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.logoImage.isError)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.logoImage.text), 1))
                            : _createCommentVNode("", true)
                        ], 2),
                        (_ctx.logoImage.isSuccess)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_67, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.logo-edit1')) + " ", 1),
                              _createElementVNode("a", {
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editLogoFile()))
                              }, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.logo-edit2')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdForm.images')), 1),
                  _createElementVNode("small", null, [
                    _createElementVNode("em", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.image-info')) + " ", 1),
                      (_ctx.dragAndDropCapable)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_71,
                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.image-drag-n-drop')), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode(_component_SortableList, {
                  list: _ctx.form.files,
                  "onUpdate:list": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.files) = $event)),
                  axis: "xy",
                  class: _normalizeClass(["form-gallery", { 'disabled-all': _ctx.isUploading }]),
                  helperClass: "thumb-drag",
                  useDragHandle: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SortableItem, {
                      disabled: true,
                      index: -1,
                      class: "thumb"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_72, [
                          _createElementVNode("input", {
                            type: "file",
                            id: "file",
                            ref: "files",
                            multiple: "",
                            onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleFilesUpload())),
                            accept: "image/bmp, image/gif, image/jpeg, image/png"
                          }, null, 544),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.button-image-upload')), 1)
                        ], 512)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.files, (image, index) => {
                      return (_openBlock(), _createBlock(_component_SortableItem, {
                        index: index,
                        key: index,
                        class: _normalizeClass(["thumb", ['thumb-' + index, { error: image.isError, 'is-empty': image.isPlaceholder }]]),
                        disabled: image.isPlaceholder
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_73, [
                            (image.isSuccess)
                              ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                  key: 0,
                                  url: image.url,
                                  width: 260,
                                  height: 195,
                                  hrmode: "max",
                                  alt: image.file,
                                  draggable: false
                                }, null, 8, ["url", "alt"]))
                              : _createCommentVNode("", true),
                            (!image.isSuccess)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: _ctx.placeholderUrl
                                }, null, 8, _hoisted_74))
                              : _createCommentVNode("", true),
                            (image.isSuccess && index < 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.$t('AdForm.image')), 1))
                              : _createCommentVNode("", true),
                            (image.text)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                  _createElementVNode("div", null, _toDisplayString(image.file), 1),
                                  _createElementVNode("div", null, _toDisplayString(image.text), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (image.isUploading)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 4,
                                  class: "progress-bar",
                                  style: _normalizeStyle({ width: image.uploadPercentage + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ])), [
                            [_directive_handle]
                          ]),
                          (image.isSuccess || image.isError)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.deleteFile(index)),
                                class: "delete-photo"
                              }, null, 8, _hoisted_77))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["index", "class", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.description.$error }])
                }, [
                  _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.description')) + ":", 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.v$.form.description.$model) = $event)),
                    id: "frm-estateAddForm_description",
                    placeholder: _ctx.$t('AdDeveloperProjectForm.description-placeholder'),
                    name: "description",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_81), [
                    [
                      _vModelText,
                      _ctx.v$.form.description.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.description.$dirty && _ctx.v$.form.description.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.description.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.countryCode.$error }])
                }, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.country')) + ":", 1),
                  _createVNode(_component_multiselect, {
                    id: "frm_estateAddForm-country",
                    modelValue: _ctx.country,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.country) = $event)),
                    "track-by": "key",
                    label: "value",
                    "show-labels": false,
                    options: _ctx.countries,
                    searchable: true,
                    "close-on-select": true,
                    placeholder: _ctx.$t('AdForm.choose-country'),
                    multiple: false,
                    "allow-empty": true
                  }, {
                    noResult: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createVNode(_component_MapPosition, {
                  position: _ctx.initialPosition,
                  onAddressChanged: _ctx.onAddressChanged,
                  country: _ctx.country.key,
                  hasError: _ctx.v$.form.address.$error,
                  label: _ctx.$t('AdDeveloperProjectForm.address')
                }, {
                  default: _withCtx(() => [
                    (_ctx.v$.form.address.$dirty && _ctx.v$.form.address.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.address.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["position", "onAddressChanged", "country", "hasError", "label"])
              ])
            ]),
            (_ctx.isInsert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("button", _hoisted_89, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.button-insert')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 34)
        ])
      ], 2),
      (_ctx.isEdit)
        ? (_openBlock(), _createBlock(_component_FixedElement, {
            key: 1,
            class: _normalizeClass(["notification-panel", _ctx.notificationClass]),
            ref: "bottomNotificationPanel",
            onChange: _ctx.updateFixedStatus,
            threshold: _ctx.$refs.topNotificationPanel && _ctx.$refs.topNotificationPanel.clientHeight,
            bottomThreshold: _ctx.bottomThreshold
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["width-wrap", { 'disabled-all': _ctx.isLoading }])
              }, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("form", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("button", {
                          class: "button button--primary",
                          type: "button",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.save(true)))
                        }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-save-short' : 'AdDeveloperProjectForm.button-save')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("button", {
                          class: "button button--primary reversed",
                          type: "button",
                          onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onShowPreview && _ctx.onShowPreview(...args)))
                        }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-preview-short' : 'AdForm.button-preview')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        (_ctx.isMobile)
                          ? (_openBlock(), _createBlock(_component_multiselect, {
                              key: 0,
                              class: "multiselect-statuses w200",
                              modelValue: _ctx.publishStatus,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.publishStatus) = $event)),
                              options: _ctx.publishStatuses,
                              "show-labels": false,
                              searchable: false,
                              "allow-empty": false
                            }, {
                              singleLabel: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('AdForm.status-change')), 1)
                              ]),
                              option: _withCtx(({ option }) => [
                                (option === 'publish')
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_96, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.isPublished) = $event)),
                                        onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                        disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                      }, null, 40, _hoisted_97), [
                                        [_vModelCheckbox, _ctx.isPublished]
                                      ]),
                                      _hoisted_98,
                                      _createElementVNode("span", _hoisted_99, [
                                        (_ctx.form.isPublished)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                            ], 64))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (option === 'archive')
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_100, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: _ctx.form.isArchived,
                                        onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                      }, null, 40, _hoisted_101),
                                      _hoisted_102
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("label", _hoisted_103, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: _ctx.form.isArchived,
                                  onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                }, null, 40, _hoisted_104),
                                _hoisted_105
                              ]),
                              _createElementVNode("label", _hoisted_106, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.isPublished) = $event)),
                                  onChange: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                  disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                }, null, 40, _hoisted_107), [
                                  [_vModelCheckbox, _ctx.isPublished]
                                ]),
                                _hoisted_108,
                                _createElementVNode("span", _hoisted_109, [
                                  (_ctx.form.isPublished)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                      ], 64))
                                ])
                              ])
                            ], 64))
                      ])
                    ])
                  ])
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["class", "onChange", "threshold", "bottomThreshold"]))
        : _createCommentVNode("", true),
      (_ctx.$refs.bottomNotificationPanel && _ctx.isHeaderFixed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: _normalizeStyle({ height: _ctx.$refs.bottomNotificationPanel.$el.clientHeight + 'px' })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 3,
            to: "#container"
          }, [
            _createVNode(_component_AdPreview, {
              adFrontId: _ctx.form.adFrontId,
              onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.showPreview = false))
            }, null, 8, ["adFrontId"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showLogoImageModal)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 4,
            to: "#container"
          }, [
            _createVNode(_component_Cropper, {
              img: _ctx.logoImage.url,
              fileName: _ctx.logoImage.file,
              aspectRatio: 16 / 9,
              accept: "image/png",
              onUpload: _ctx.uploadLogoImage,
              onClose: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showLogoImageModal = false))
            }, null, 8, ["img", "fileName", "onUpload"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}